import { createGlobalStyle } from "styled-components";

const MapPopupGlobalStyles = createGlobalStyle`
  .maplibregl-popup-contextual {
    z-index: ${(p) => p.theme.zIndexes.mapItem};
    opacity: 0;

    /* Styled-components nesting rules require the & here to properly target */
    & .maplibregl-popup-content {
      padding: 0.75rem;
      border-radius: ${(p) => p.theme.borderRadiuses.lg}px;
      box-shadow: ${(p) => p.theme.boxShadows.md};
      color: ${(p) => p.theme.colors.neutrals.text};
      background-color: ${(p) => p.theme.colors.neutrals.background};
    }

    &.full-width {
      width: 100%;
    }

    &:not(.full-width) .maplibregl-popup-content {
      padding: 0.5rem 0.75rem;
    }

    &.hover {
      z-index: ${(p) => p.theme.zIndexes.hoverMapItem};
    }

    &.no-tip .maplibregl-popup-tip {
      display: none;
    }

    &.inverse .maplibregl-popup-content {
      color: ${(p) => p.theme.colors.neutrals.textInverse};
      background-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-bottom .maplibregl-popup-tip {
      border-top-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip {
      border-top-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip {
      border-top-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-top .maplibregl-popup-tip {
      border-bottom-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-top-left .maplibregl-popup-tip {
      border-bottom-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-top-right .maplibregl-popup-tip {
      border-bottom-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-left .maplibregl-popup-tip {
      border-right-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.inverse.maplibregl-popup-anchor-right .maplibregl-popup-tip {
      border-left-color: ${(p) => p.theme.colors.neutrals.backgroundInverse};
    }

    &.loaded {
      opacity: 1;
    }

    &.maplibregl-popup-anchor-top-right .maplibregl-popup-content {
      border-top-right-radius: 0;
    }

    &.maplibregl-popup-anchor-top-left .maplibregl-popup-content {
      border-top-left-radius: 0;
    }

    &.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content {
      border-bottom-right-radius: 0;
    }

    &.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content {
      border-bottom-left-radius: 0;
    }
  }
`;

export default MapPopupGlobalStyles;
